import { Link } from 'react-router-dom';
import { CalendarPlus, MessageSquare, Bot } from 'lucide-react';
import { cn } from '@/lib/utils';

const quickActions = [
  { icon: CalendarPlus, label: 'Book', fullLabel: 'Book Appointment', path: '/schedule-appointment' },
  { icon: MessageSquare, label: 'Message', fullLabel: 'Message Doctor', path: '/messages' },
  { icon: Bot, label: 'AI', fullLabel: 'AI Assistant', path: '/ai-assistant' },
];

export function QuickActionsBar() {
  return (
    <div className="border-t border-gray-200 dark:border-gray-700 p-3">
      <p className="mb-2 text-[10px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">
        Quick Actions
      </p>
      <div className="flex items-center gap-2">
        {quickActions.map((action) => {
          const Icon = action.icon;
          return (
            <Link
              key={action.path}
              to={action.path}
              className={cn(
                'flex items-center gap-1.5 flex-1 justify-center',
                'px-2.5 py-2 rounded-full text-xs font-medium',
                'bg-gray-100 dark:bg-gray-800',
                'text-gray-600 dark:text-gray-300',
                'hover:bg-primary-50 dark:hover:bg-primary-950/50',
                'hover:text-primary-600 dark:hover:text-primary-400',
                'transition-colors duration-150',
                'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500',
              )}
              title={action.fullLabel}
            >
              <Icon className="w-3.5 h-3.5 flex-shrink-0" />
              <span className="truncate">{action.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
